export const QUESTIONS_COUNT = 2;
